import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';
// import { useSeasonalBranding } from '../../../../../store/featureFlags/featureFlagsStore';
import styles from './VipBellLinkBoost.module.css';

const VipBellLinkBoostJackpot: FC<StandardJackpotProps> = (props) => {
  // const seasonalBranding = useSeasonalBranding();
  // TODO: Uncomment when seasonal branding assets are added

  const vipBellLinkBoostIcons = {
    // panel: seasonalBranding ? `/brandings/${seasonalBranding}/group_vip_bell_link_boost/panel` : '/group_vip_bell_link_boost/panel',
    panel: '/group_vip_bell_link_boost/panel',
    grand: '/group_vip_bell_link_boost/grand',
    major: '/group_vip_bell_link_boost/major',
    minor: '/group_vip_bell_link_boost/minor',
    mini: '/group_vip_bell_link_boost/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={vipBellLinkBoostIcons}
      className={styles['vipBellLinkBoostTheme']}
    />
  );
};

export default memo(VipBellLinkBoostJackpot);
